/**
 * @generated SignedSource<<09e215b23c23314f1421fa6a941a5b47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageBenefitsSummary_package$data = {
  readonly benefitsSummary: ReadonlyArray<{
    readonly description: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "PackageBenefitsSummary_package";
};
export type PackageBenefitsSummary_package$key = {
  readonly " $data"?: PackageBenefitsSummary_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageBenefitsSummary_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageBenefitsSummary_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BenefitsSummaryLine",
      "kind": "LinkedField",
      "name": "benefitsSummary",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": "__isPackage"
};

(node as any).hash = "023b5c9c8167e57ee6520403faf259ed";

export default node;
